module.exports = __webpack_public_path__ + "static/media/Getty_Images_160375427_tablet.4b01e801.jpg";